module.exports = __webpack_public_path__ + "img/4B362C_715A4F_211913_644C44-256px.48a6cc3e.png";